import loadable from '@loadable/component';

export const ReportsDetailGraphicConfigurationFilterOnlyFeedbackWithComments = loadable(
  () => import('./ReportsDetailGraphicConfigurationFilterOnlyFeedbackWithComments'),
);
